import { RouteTypes } from 'consts';
import Header from 'containers/Header';
import Table from 'containers/Table';
import { useList } from 'hooks/list';
import { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { RfUiBreadcrumbs, RfUiModal } from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  setLoading,
  setModalDraftType,
  setMsgSubmit,
} from 'store/app/actions';
import {
  getExcelCoursesClosing,
  getReportCoursesClosing,
  getReportCoursesClosingCount,
  setEstadoCurso,
  setReportCoursesClosingCount,
} from 'store/cursos/actions';
import {
  makeSelectAllSociedades,
  makeSelectCursosCierre,
  makeSelectCursosCierreCount,
} from 'store/cursos/selectors';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import { estados } from 'utils/estados';
import { hasAccess } from 'utils/listUtils';
import { calculateDaysClosure, parseDate } from 'utils/parsePractices';
import { userProfile } from 'utils/profilesIndex';
import { ReportCoursesClosingFilter } from './ReportCoursesClosingFilter/ReportCoursesClosingFilter';
import { makeSelectModalDraftType, makeSelectMsgSubmit } from 'store/app/selectors';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  access_token: makeSelectTokenAccessToken(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  cursos: makeSelectCursosCierre(),
  cursosCount: makeSelectCursosCierreCount(),
  allSociedades: makeSelectAllSociedades(),
} as any);

export const nomPagina = 'Informes de cursos pendientes de cierre';
export const links = [
  {
    label: 'Informes',
    link: '#',
    textHelp: 'Informes',
    active: true,
  },
];

const initFilter = {
  elemInicio: 0,
  // elemFin: 10, // Algunas peticiones cambian el nombre del parámetro
  elemFinal: 10,
  orden: '',
  ascDesc: '',
  sociedades: '',
  provincias: '',
};

const options =
  '[{"label": "Fecha inicio de menor a mayor","value": {"order":"FECHA_INI_CURSO","ascDesc": "asc"},"active": "true"},{"label": "Fecha inicio de mayor a menor","value": {"order":"FECHA_INI_CURSO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de mayor a menor","value": {"order":"FECHA_FIN_CURSO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de menor a mayor","value": {"order":"FECHA_FIN_CURSO","ascDesc": "asc"},"active": "false"}]';

const Courses = (): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { access_token, cursos, profileActive, cursosCount, allSociedades, msgSubmit, modalDraftType } =
    useSelector<any, any>(selectors);
  const redirect = (e: any) => {
    history.push(e.detail);
  };
  const {
    filterRef,
    data,
    setData,
    headers,
    handleFilterTable,
    handleFilterChange,
  } = useList(
    { ...initFilter },
    [
      { text: 'Curso' },
      { text: 'Nombre curso' },
      {
        text: 'Desde',
        orderBy: 'asc',
        ariaLabelIcon: 'Icono de ordenar',
      },
      {
        text: 'Hasta',
        orderBy: 'asc',
        ariaLabelIcon: 'Icono de ordenar',
      },
      { text: 'Sociedad' },
      { text: 'Provincia' },
      { text: 'Modificación' },
      { text: 'Usuario modificación' },
      { text: 'Cambio estado' },
      { text: 'Estado' },
      { text: 'Días sin cierrre' },
    ],
    {
      action: (filter) => dispatch(getReportCoursesClosing(filter)),
      headerToAPIMap: {
        Desde: 'FECHA_INI_CURSO',
        Hasta: 'FECHA_FIN_CURSO',
      },
    },
    (filter) => {
      dispatch(setReportCoursesClosingCount(-1));

      dispatch(getReportCoursesClosing(filter));
      dispatch(getReportCoursesClosingCount(filter));
    },
    async () => {
      dispatch(setLoading(true));
      await new Promise(resolve => setTimeout(resolve, 90));
      dispatch(setLoading(false));
    }
  );

  const handleExportExcel = () => {
    dispatch(
      getExcelCoursesClosing({
        filter: { ...filterRef.current },
        excelConfig: {
          literals: headers,
        },
      })
    );
  };


const handleCellSelect = (e) => {
  if (
    profileActive?.ID_PERFIL == userProfile.supervisor ||
    profileActive?.ID_PERFIL == userProfile.visualizador
  ) {
    return;
  }

  const detail = e.detail.estado ? e.detail : e.detail.detail;

  const coursestatus = detail.estado;
  const detailitem = detail.item;

  if (coursestatus !== detailitem.ID_ESTADO) {
    setData([]);

    dispatch(
      setEstadoCurso({
        params: {
          estadoId: coursestatus,
          cursoId: detailitem.ID_CURSO,
        },
        filter: { ...filterRef.current },
        cursosCierre: true,
      })
    );
  }
};
  useEffect(() => {
    if (profileActive && allSociedades.length) {
      dispatch(getReportCoursesClosing(filterRef.current));
      dispatch(getReportCoursesClosingCount(filterRef.current));
    }
  }, [profileActive, allSociedades]);
  const accessToAlumns = hasAccess(
    profileActive,

    [userProfile.formador, userProfile.gestor, userProfile.administrador, userProfile.supervisor, userProfile.visualizador]
  );
  useEffect(() => {
    if (!profileActive || !allSociedades.length) {
      return;
    }

    const cursosParsed = cursos.map((item) => {
      const link = accessToAlumns ? '/listado-alumnos/' + item.ID_CURSO : '';
      const canSeeOptions = !(String(profileActive?.ID_PERFIL) == userProfile.supervisor || String(profileActive?.ID_PERFIL) == userProfile.visualizador);

      return {
        table: [
          [
            {
              text: item.ID_CURSO,
              urlLink: link,
            },
            { text: item.NOMBRE_CURSO },
            { text: parseDate(item.FECHA_INI_CURSO) },
            { text: parseDate(item.FECHA_FIN_CURSO) },
            {
              text: allSociedades.find(
                (sociedad) => sociedad.ID_SOCIEDAD === item.SOCIEDAD_CURSO
              ).NOMBRE_SOCIEDAD,
            },
            { text: item.PROVINCIA_CURSO },
            {
              text:
                item.FECHA_MODIFICACION !== null && item.FECHA_MODIFICACION !== 0
                  ? parseDate(item.FECHA_MODIFICACION)
                  : 'Sin fecha',
            },
            { text: item.USUARIO_MOD || '-' },
            {
              text:
                item.FECHA_CAMBIO_EST !== null && item.FECHA_CAMBIO_EST !== 0
                  ? parseDate(item.FECHA_CAMBIO_EST)
                  : 'Sin fecha',
            },
            canSeeOptions
              ? {
                  select: [
                    {
                      options: [
                        {
                          label: estados[item.ID_ESTADO],
                          value: {
                            estado: item.ID_ESTADO,
                            item,
                          },
                          active: 'true',
                        },
                        {
                          label: estados.CE,
                          value: {
                            estado: 'CE',
                            item,
                          },
                          active: 'false',
                        },
                      ],
                      placeholder: '',
                      disabled: false,
                      withoutOptionsText: false,
                    },
                  ],
                }
              : {
                  text: estados[item.ID_ESTADO],
                },
            { text: calculateDaysClosure(item.FECHA_FIN_CURSO) },
          ],
        ],
      };
    });

    setData(cursosParsed);
  }, [cursos]);

  if (
    !hasAccess(profileActive, [userProfile.gestor, userProfile.administrador, userProfile.supervisor, userProfile.visualizador])
  ) {
    return <Redirect to={RouteTypes.HOME} push />;
  }

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  return (
    <>
      <Header />
      <div className="rf-layout-table rf-practice-list">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">
          Informes de cursos pendientes de cierre
        </h1>

        <ReportCoursesClosingFilter
          handleSubmit={handleFilterChange}
          data={data}
        />

        <Table
          redirect={(e: any) => {
            redirect(e);
          }}
          list={false}
          data={data}
          dataCount={cursosCount}
          headers={headers}
          handleFilter={handleFilterTable}
          hideAudit={true}
          itemsOnLeft={5}
          showSelectList={true}
          orderMobile={true}
          orderOptions={options}
          handleExportExcel={handleExportExcel}
          handleCellSelect={handleCellSelect}
        />
        <RfUiModal
          title-modal={msgSubmit}
          modalConfirmText="Aceptar"
          id-modal="modalDraft"
          modal-type={modalDraftType}
          onModalClose={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
          onConfirm={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
        ></RfUiModal>
      </div>
    </>
  );
};

export default Courses;
